// HelpCenterData.tsx
import React from "react";

export type FAQItem = { q: string; a: React.ReactNode };
export type FAQSection = { id: string; title: string; items: FAQItem[] };

export type TrainingTile = {
  title: string;
  description: string;
  videoLength: string;
  videoUrl: string;   // player URL is fine (we convert for oEmbed thumbnail)
  jobAidUrl: string;  // share URL is fine (we convert to download=1 in UI)
  thumbnailUrl?: string; // optional override
};

// export const trainingTiles: TrainingTile[] = [
//   {
//     title: "JO GPT Sharing Training",
//     description: "Ensure your files and folders are accessible while maintaining control and security. Nothing is shared by default; you maintain full control over what information becomes available.",
//     videoLength: "3:11",
//     videoUrl: "https://vimeo.com/1156549470/176a7c6e8d",
//     jobAidUrl: "https://app.box.com/shared/static/trcehdb66z65qaq5fkw3ukwnq72j92g3.pdf",
//   },
//   {
//     title: "Prompt Training Guide CUPS",
//     description: "The CUPS prompting framework is designed to ensure you provide JO GPT with all the necessary components for a high-quality, relevant response.",
//     videoLength: "4:15",
//     videoUrl: "https://vimeo.com/1157615791/c152bf430f",
//     jobAidUrl: "https://app.box.com/shared/static/evrvs50lxf4d0z4ykfrbugf50y3qldhh.pdf",
//   },
//   {
//     title: "Folder/File Focus mode",
//     description: "In focus mode, the search is restricted to a specific folder or set of files that the user has selected.",
//     videoLength: "1:36",
//     videoUrl: "https://vimeo.com/1160288428/2f276712ce",
//     jobAidUrl: "https://app.box.com/shared/static/c3s2hu8hyive8eceqs9x9uhuyw5gkd24.pdf",
//   },
//   {
//     title: "Deep search",
//     description: "The Deep Search function is a powerful tool that significantly enhances JobsOhio employees’ ability to locate detailed organizational and prospect information.",
//     videoLength: "2:18",
//     videoUrl: "https://vimeo.com/1160292792/8a82007c45",
//     jobAidUrl: "https://app.box.com/shared/static/0fiqdic3jugikuv9legkbevcc553z5pt.pdf",
//   },
// ];
export type TrainingSection = { id: string; title: string; tiles: TrainingTile[] };

// Training videos, grouped into sections shown top to bottom — the newest
// videos first, older ones under Archive.
export const trainingSections: TrainingSection[] = [
  {
    id: "new",
    title: "New",
    tiles: [
      {
        title: "Model Selection",
        description: "Learn how to choose the right Claude or GPT model in JO Enterprise Chat so you get the speed and depth your task needs.",
        videoLength: "2:01",
        videoUrl: "https://player.vimeo.com/video/1233078135?h=cee0d25cfc",
        jobAidUrl: "https://app.box.com/shared/static/zn76beeo8xhw77rqfl1f49g6ufpt02d4.pdf",
      },
      {
        title: "Image Generation",
        description: "Learn how to turn a written description into an original image using Create Image in JO Enterprise Chat.",
        videoLength: "1:44",
        videoUrl: "https://player.vimeo.com/video/1234078206?h=552c39e6c9",
        jobAidUrl: "https://app.box.com/shared/static/ohlwnbe291iybw71zvj9zisbsvc0xwcp.pdf",
      },
      {
        title: "Web Search",
        description: "Learn how to bring current information from the internet into your conversations and combine it with your internal sources.",
        videoLength: "1:48",
        videoUrl: "https://player.vimeo.com/video/1233381234?h=0277943dd0",
        jobAidUrl: "https://app.box.com/shared/static/poi08rv2po3k1z8blrrshdaahglfrgxl.pdf",
      },
      {
        title: "Multi Source Selection",
        description: "Learn how to choose and combine sources like Salesforce, Box, and Tableau so each answer draws from exactly the information you need.",
        videoLength: "1:45",
        videoUrl: "https://player.vimeo.com/video/1233387803?h=8e7f70a2ae",
        jobAidUrl: "https://app.box.com/shared/static/bpaiheivqv2osyhwi4zsiru50wtd5qxq.pdf",
      },
      {
        title: "Atlas Integration",
        description: "Learn how to use Atlas and Deep Insights inside JO Enterprise Chat for quick lead information and full lead intel reports.",
        videoLength: "1:47",
        videoUrl: "https://player.vimeo.com/video/1233392582?h=e0909836b8",
        jobAidUrl: "https://app.box.com/shared/static/ik2296oaeas6sm0qewazaxwnyq2qj8dl.pdf",
      },
      {
        title: "Document Generation",
        description: "Learn how to ask JO Enterprise Chat to create a document for you, refine it in the chat, and download it to your device.",
        videoLength: "1:53",
        videoUrl: "https://player.vimeo.com/video/1233395693?h=7d062ffda5",
        jobAidUrl: "https://app.box.com/shared/static/r4meps6yq5ohwzadatl0uelg3hhtaua3.pdf",
      },
    ],
  },
  {
    id: "archive",
    title: "Archive",
    tiles: [
      {
        title: "JO GPT Sharing Training",
        description: "Ensure your files and folders are accessible while maintaining control and security. Nothing is shared by default; you maintain full control over what information becomes available.",
        videoLength: "3:11",
        // CHANGED: From vimeo.com/ID/HASH to player.vimeo.com/video/ID?h=HASH
        videoUrl: "https://player.vimeo.com/video/1156549470?h=176a7c6e8d",
        jobAidUrl: "https://app.box.com/shared/static/trcehdb66z65qaq5fkw3ukwnq72j92g3.pdf",
      },
      {
        title: "Prompt Training Guide CUPS",
        description: "The CUPS prompting framework is designed to ensure you provide JO GPT with all the necessary components for a high-quality, relevant response.",
        videoLength: "4:15",
        videoUrl: "https://player.vimeo.com/video/1157615791?h=c152bf430f",
        jobAidUrl: "https://app.box.com/shared/static/evrvs50lxf4d0z4ykfrbugf50y3qldhh.pdf",
      },
      {
        title: "Deep search",
        description: "The Deep Search function is a powerful tool that significantly enhances JobsOhio employees’ ability to locate detailed organizational and prospect information.",
        videoLength: "2:18",
        videoUrl: "https://player.vimeo.com/video/1160292792?h=8a82007c45",
        jobAidUrl: "https://app.box.com/shared/static/0fiqdic3jugikuv9legkbevcc553z5pt.pdf",
      },
      {
        title: "History & Chat Organization",
        description: "The History feature allows you to access your previous conversations and keep them neatly organized in folders.",
        videoLength: "3:12",
        videoUrl: "https://player.vimeo.com/video/1176608465?h=a569f4c97b",
        jobAidUrl: "https://app.box.com/shared/static/ir2owyu2ltz7766h3s28pkyfgvuvlc7z.pdf",
      },
      {
        title: "Compose Mode",
        description: "A quick walkthrough of Compose Mode in JO-GPT, showing users how to access and use the feature to get better AI-generated outputs for everyday writing tasks.",
        videoLength: "1:53",
        videoUrl: "https://player.vimeo.com/video/1204881148?h=d41caa2913",
        jobAidUrl: "https://app.box.com/shared/static/z7ovgllk9hbrbk72ltgtqlerigxao0tm.pdf",
      },
    ],
  },
];

// Every training video across all sections (tab count, thumbnail loading).
export const trainingTiles: TrainingTile[] = trainingSections.flatMap((s) => s.tiles);

// The EDA team's contact address, as a mailto link — used across many answers.
const EDA_EMAIL = "Enterprise-Data-AI@JobsOhio.com";
const edaEmail = () => <a href={`mailto:${EDA_EMAIL}`}>{EDA_EMAIL}</a>;

export const faqSections: FAQSection[] = [
  {
    id: "getting-started",
    title: "Getting Started",
    items: [
      {
        q: "How do I access the JobsOhio Enterprise Chat?",
        a: (
          <>
            You can access the chat tool through your Okta dashboard by clicking on the JobsOhio
            Enterprise Chat tile, or you can visit the site directly at{" "}
            <a href="https://chat.jobsohio.com" target="_blank" rel="noopener noreferrer">
              chat.jobsohio.com
            </a>
            .
          </>
        ),
      },
      {
        q: "Can I use JobsOhio Enterprise Chat from my phone or only on desktop?",
        a: "The tool is optimized for desktop browsers and is not formatted for a mobile experience at this time.",
      },
      {
        q: "Do I need to sign in?",
        a: "You won't need to log in each time you access the chat tool if you're already signed into your Okta dashboard. However, you will be prompted to accept the user agreement each time you open the tool.",
      },
      {
        q: "Where can I find prompt training, demo sessions, or training videos?",
        a: (
          <>
            Group Prompt Training & Live Demo sessions are being offered for a limited time.
            Training videos are available in the Help Center under{" "}
            <a href="/help?tab=training">Training Materials</a>. Once the
            scheduled classes are completed, you can request a one-on-one lab session by
            emailing {edaEmail()}.
          </>
        ),
      },
      {
        q: "How do I start a new chat?",
        a: "Click New Chat from the left navigation bar to start fresh.",
      },
    ],
  },
  {
    id: "using-the-tool",
    title: "Using the Tool",
    items: [
      {
        q: "How do I write a good prompt?",
        a: (
          <>
            Be clear and specific. Include context, the desired output format, and any examples.
            (Refer to the Prompt Training Guide CUPS inside the{" "}
            <a href="/help?tab=training">Training Material</a> section.)
          </>
        ),
      },
      {
        q: "How do I choose a source for my question?",
        a: 'Click the + button to open the Source menu. "All" is selected by default and searches every connected source. To narrow your results, click on the source you want, such as Box Sharing or Salesforce. A check mark appears next to it, and its name appears in the chat window. To combine sources, click on more than one. You can include File Upload and Web Search in your selection. Choosing sources is helpful when you already know where the answer lives. You can also use Focus Mode to select a specific folder, file, or dashboard within a source.',
      },
      {
        q: "When should I combine sources?",
        a: 'Combine sources when your answer may live in more than one place, or when you want to compare internal data with an uploaded file or current public information. For example, you could select Salesforce and Web Search together, then ask: "Summarize the Anduril project in Salesforce and list recent events happening at the company." JobsOhio data stays within JobsOhio, and Web Search only adds public information to the answer. As noted in the Disclaimers, do not share sensitive personal or confidential company information with the chat.',
      },
      {
        q: "How do I know which sources are active?",
        a: "Check the chat window. The name of each selected source appears there. To remove a source, click it a second time in the Source menu to clear the check mark.",
      },
      {
        q: "What is the difference between Atlas and Deep Insights?",
        a: "Both are under Atlas Lead Intelligence. Atlas gives you general information about a lead or company. Deep Insights produces a more detailed lead intelligence report and takes longer to run. Use Atlas for a quick look and Deep Insights when you need a fuller picture.",
      },
      {
        q: "When should I use Deep Search, and why does it take longer?",
        a: "Use Deep Search for complex questions that need information from several places. It runs a thorough, multi-step search across all sources and combines what it finds, so it takes longer than a standard question. For simple lookups, regular chatting is faster.",
      },
      {
        q: "How do I use Compose to draft written content?",
        a: "Select Compose from the Source menu, then describe what you want to write, such as an email, summary, or document. Include the audience, tone, and key points for the best result. You can then ask for revisions, like making it shorter or more formal. Review all drafts before sending or sharing and refer to the Legal Department's Definitions of Confidential Data and the Disclaimers before including company information.",
      },
      {
        q: "How do I share a chat or output?",
        a: "You can manually copy and paste chat responses or output data to share with others. Before doing so, please review the Legal Department's Definitions of Confidential Data and the Disclaimers to ensure compliance with data-sharing guidelines.",
      },
      {
        q: "What file formats can the chat produce?",
        a: "The chat can produce PNG, Excel, CSV, Word, and PDF files. Ask for the format in your prompt, for example, \"Create an Excel file with this table.\" Review all output before sharing and refer to the Legal Department's Definitions of Confidential Data.",
      },
      {
        q: "Is there a character or token limit for responses?",
        a: "At this point we are not restricting the output tokens.",
      },
    ],
  },
  {
    id: "prompt-engineering",
    title: "Prompt Engineering",
    items: [
      {
        q: "What is C.U.P.S. and how do I use it?",
        a: (
          <>
            C.U.P.S. = Context, Use Case, Product, Structure. It's a prompt framework to help you
            create effective queries. You can learn more about it by visiting the{" "}
            <a href="/help?tab=training">Training Materials</a> section inside the Help Center.
          </>
        ),
      },
      {
        q: "How can I refine a prompt to get better results?",
        a: 'Rephrase questions, narrow scope, or ask the tool to "explain reasoning" to improve clarity and precision.',
      },
      {
        q: "How do I request structured outputs (markdown format, bullet lists, summaries, tables)?",
        a: 'Specify your desired format directly in your prompt, for example, "Provide this as a bullet list" or "Provide this as a table."',
      },
    ],
  },
  {
    id: "sources-integrations",
    title: "Sources & Integrations",
    items: [
      {
        q: "Does the chat tool connect with other internal systems?",
        a: "Yes. The Source menu includes Atlas Lead Intelligence, Box Sharing, JOBIT Talking Points, Salesforce, Tableau Dashboard, and the JobsOhio Website. For Salesforce, the Projects and Programs tables are currently available. For Tableau, the Projects and Programs dashboards are currently integrated, with additional JOALL dashboards planned for future integration. You can search one source at a time or select several at once, and File Upload and Web Search can be added to your selection.",
      },
      {
        q: "Can I search more than one source at once?",
        a: 'Yes. Click on each source you want to use. A check mark appears next to every source you select, and the selected source names appear in the chat window. You can also add File Upload and Web Search to your selection. "All" searches every connected source, and Deep Search runs across all sources.',
      },
      {
        q: "What is JOBIT Talking Points?",
        a: "JOBIT Talking Points is a source of approved messaging that helps keep communication consistent. The content is maintained by the Research Team.",
      },
      {
        q: "Can I ask questions about Salesforce, Box, or Tableau data?",
        a: "Yes. Choose the matching source from the menu and ask your question in plain language. Your access in the chat matches your access in each tool. For Salesforce, the Projects and Programs tables are currently available. For Tableau, the Projects and Programs dashboards are currently integrated, with additional JOALL dashboards planned. Box content is internal JobsOhio data and can vary depending on what you have access to. You must grant the tool permission to access your Box data.",
      },
      {
        q: "Can I request new data sources to be added?",
        a: (
          <>
            Please submit your request to {edaEmail()}. It will be reviewed and considered for
            inclusion in future updates or enhancements.
          </>
        ),
      },
      {
        q: "How often is the data in each source updated?",
        a: "Salesforce, Tableau, and JOBIT Talking Points are updated daily. The JobsOhio Website and Atlas Lead Intelligence are searched live, so results reflect what is currently on the JobsOhio site and in Atlas. Box data is updated whenever new information is shared. Depending on the volume of data ingested, it may become available in the chat tool in as little as 15 minutes or may take up to a full day.",
      },
    ],
  },
  {
    id: "web-search",
    title: "Web Search",
    items: [
      {
        q: "What does Web Search do, and when should I turn it on?",
        a: "Web Search adds current information from the public internet to your answers. Turn it on when you need recent news or facts that internal sources would not include. Leave it off when your question is only about internal data. JobsOhio data stays within JobsOhio, and Web Search only brings in additional public information. As noted in the Disclaimers, do not share sensitive personal or confidential company information with the chat.",
      },
      {
        q: "Is Web Search on by default?",
        a: "No. Web Search is off until you turn it on, and you need to turn it on in each new chat. Once it is on, you can keep asking questions in the same chat without turning it on again.",
      },
    ],
  },
  {
    id: "file-upload",
    title: "File Upload & Image Creation",
    items: [
      {
        q: "Can I upload files or data for the chat tool to use?",
        a: (
          <>
            <p>Yes, you can share data via Box Sharing or the File Upload option.</p>
            <ul className="hc-bullets">
              <li><strong>Supported formats:</strong> pdf, docx, xlsx, csv, pptx, txt, jpeg, jpg, png</li>
              <li><strong>Upload limit:</strong> Up to 10 files at once, up to 25 MB each</li>
              <li><strong>Not supported:</strong> Audio and video files</li>
              <li><strong>Privacy:</strong> Your uploaded files are accessible by you and pre-approved personnel</li>
              <li><strong>Availability:</strong> Files are available during your current session. If you close the session, the file remains in your chat history until the conversation is automatically deleted after 30 days of no use.</li>
            </ul>
          </>
        ),
      },
      {
        q: "Can I upload an image and ask questions about it?",
        a: "Yes. Upload a JPEG, JPG, or PNG file, using File Upload and then ask your question in the chat. For example, you could upload a screenshot or chart and ask the chat to describe it or answer questions about what it shows. Review all responses before sharing, and do not upload images that contain confidential information unless you are permitted to share them under the Legal Department's Definitions of Confidential Data.",
      },
      {
        q: "How do I create an image from a description?",
        a: "Select Create Image from the menu, then describe what you want, including subject, style, colors, and mood. You can ask for changes to refine the results. Follow Legal guidance when using generated images, and review the Disclaimers and the Legal Department's Definitions of Confidential Data before sharing them.",
      },
    ],
  },
  {
    id: "ui-customization",
    title: "UI & Customization",
    items: [
      {
        q: "What do the icons and buttons on the interface mean?",
        a: (
          <>
            <p>Hover over any icon or menu option for a quick tooltip. The following buttons and options are available:</p>

            <ul className="hc-bullets">
              <li>
                <strong>Edit:</strong> Modify your original prompt to refine the AI's response.
              </li>
              <li>
                <strong>Copy Content:</strong> Copy the generated response to your clipboard.
              </li>
              <li>
                <strong>Alternate Response:</strong> Generate a different take based on the same prompt.
              </li>
              <li>
                <strong>Stop Chat Processing:</strong> Stop the current response so you can start fresh.
              </li>
              <li>
                <strong>+:</strong> Open the Source menu to select one or more sources for more accurate and relevant results.
              </li>
              <li>
                <strong>Focus Mode:</strong> Select a folder, file, or dashboard to focus on within the selected source.
              </li>
              <li>
                <strong>Compose:</strong> Draft and refine written content.
              </li>
              <li>
                <strong>Create Image:</strong> Generate images from a description.
              </li>
              <li>
                <strong>File Upload:</strong> Ask questions about an attached file.
              </li>
              <li>
                <strong>Web Search:</strong> Add current information from the web.
              </li>
              <li>
                <strong>Deep Search:</strong> Run a thorough search across all sources. Takes longer to run.
              </li>
            </ul>
          </>
        ),
      },

      {
        q: "Can I change the theme (dark/light mode)?",
        a: "No, dark/light mode is not available at this time but will be considered in future updates.",
      },
      {
        q: "Can I customize the sidebar or rearrange it?",
        a: "No, the left navigation sidebar is unable to be rearranged manually.",
      },
    ],
  },
  {
    id: "data-privacy-access",
    title: "Data Privacy & Access",
    items: [
      {
        q: "Who can see my chats?",
        a: "Pre-approved personnel will have access to chat history, including uploaded files and Web Search queries.",
      },
      {
        q: "Are my chats stored or used for model training?",
        a: "Chats are stored for functionality but are not used to train models or shared outside the organization.",
      },
      {
        q: "Can I delete a conversation?",
        a: "Yes, you can manually delete a conversation. Also, conversations are automatically deleted after 30 days of no use.",
      },
      {
        q: "How does the tool handle confidential information?",
        a: (
          <ul className="hc-bullets">
            <li>
              <strong>Tool Access:</strong> Users must have access to the chat tool.
            </li>
            <li>
              <strong>Box, Tableau, and Salesforce Access:</strong> Your permissions in each tool carry over to the chat. You can only see what you already have access to in that tool.
            </li>
            <li>
              <strong>Tool Integration Permissions:</strong> Users must grant the tool permission to access their Box data.
            </li>
            <li>
              <strong>Web Search:</strong> JobsOhio data stays within JobsOhio, and Web Search only brings in additional public information.
            </li>
            <li>
              <strong>Confidentiality:</strong> As noted in the Disclaimers, do not share sensitive personal or confidential company information with the chat.
            </li>
          </ul>
        ),
      },
      {
        q: "Will I see data I don't normally have access to in Salesforce, Box, or Tableau?",
        a: "No. Box, Tableau, and Salesforce permissions are active in the chat, so the access you have in those tools is the access you have in the chat. If you can't find something you expect, check with the owner of that system about your access.",
      },
      {
        q: "Are uploaded files and Web Search queries stored or shared?",
        a: "Uploaded files are accessible by you and pre-approved personnel. It stays in your chat history until the conversation is automatically deleted after 30 days of no use. JobsOhio data does not leave the organization when Web Search is on, and chats are not used to train models.",
      },
    ],
  },
  {
    id: "troubleshooting",
    title: "Troubleshooting",
    items: [
      {
        q: "Who do I contact if I find a bug or something isn't loading correctly?",
        a: (
          <>
            You can click on the "thumbs-down" icon in the responses to report issues related to the
            responses. You can also use the Contact Us option available on the left navigation panel
            or send an email to {edaEmail()}
          </>
        ),
      },
      {
        q: "Why is my search taking so long or returning no results?",
        a: (
          <>
            Deep Search and Deep Insights take longer by design, so allow extra time. For other slow
            searches, try narrowing the source or simplifying your question. If you get no results,
            rephrase the question or try a different source. A source also returns no results if you
            don't have access to it in that tool. If the problem continues, use the Contact Us button
            in the left navigation or email {edaEmail()}.
          </>
        ),
      },
      {
        q: "Why does a source return no results?",
        a: (
          <>
            Your access in the chat matches your access in each tool. If you don't have permission in
            Box, Tableau, or Salesforce, that source will return no results. If you expect to see
            information and don't, check with the owner of that system about your access. You can
            also email {edaEmail()}. For issues with your account, submit a HelpDesk ticket with OSA.
          </>
        ),
      },
    ],
  },
  {
    id: "feedback-support",
    title: "Feedback & Support",
    items: [
      {
        q: "How do I share feedback or suggest a new feature?",
        a: "Click the Contact Us button in the left navigation panel.",
      },
      {
        q: "Who do I contact for technical or account issues?",
        a: (
          <>
            You can click on the "thumbs-down" icon in the responses to report issues related to the
            responses. You can also use the Contact Us option available on the left navigation panel
            or send an email to {edaEmail()} for technical issues. For issues with your account,
            please submit a HelpDesk ticket with OSA.
          </>
        ),
      },
    ],
  },
  {
    id: "disclaimers",
    title: "Disclaimers",
    items: [
      {
        q: "1. Legal or Contractual Authority",
        a: (
          <ul className="hc-bullets">
            <li>
              The JO Enterprise Chat responses are not legally binding, and do not constitute or convey legal advice. You should not act upon any JO Enterprise Chat responses or information without first seeking qualified professional guidance from JobsOhio's legal counsel on your specific question or matter.
            </li>
          </ul>
        ),
      },
      {
        q: "2. Accuracy & Reliability",
        a: (
          <ul className="hc-bullets">
            <li>
              JO Enterprise Chat responses are generated based on users' permissions, available data, and programmed logic. While we strive for accuracy, we cannot guarantee that all information is complete, correct, or up to date.
            </li>
            <li>
              Users should verify any information provided by the JO Enterprise Chat before relying on its output.
            </li>
          </ul>
        ),
      },
      {
        q: "3. IT & Security Disclaimer",
        a: (
          <ul className="hc-bullets">
            <li>
              Use of the JO Enterprise Chat is subject to JobsOhio's IT Usage and AI Governance policies and processes. Misuse may result in access restrictions or disciplinary action.
            </li>
            <li>
              Reviewing any content produced by the JO Enterprise Chat remains a critical security measure.
            </li>
          </ul>
        ),
      },
      {
        q: "4. HR Authority",
        a: (
          <ul className="hc-bullets">
            <li>
              The JO Enterprise Chat does not replace or take precedence over official Human Resources communications, employee handbooks, or direct guidance from Human Resources staff.
            </li>
            <li>
              Do not use the JO Enterprise Chat for issues involving workplace disputes, disciplinary matters, or sensitive personal circumstances. Users should contact HR directly.
            </li>
          </ul>
        ),
      },
      {
        q: "5. Confidentiality & Data Handling",
        a: (
          <ul className="hc-bullets">
            <li>
              In compliance with the Standards of Conduct, do not share sensitive personal or confidential company information with the JO Enterprise Chat.
            </li>
          </ul>
        ),
      },
      {
        q: "6. Compliance & Policy Alignment",
        a: (
          <ul className="hc-bullets">
            <li>
              The JO Enterprise Chat does not replace or take precedence over JobsOhio's policies, processes, or compliance requirements.
            </li>
          </ul>
        ),
      },
    ],
  },
  {
    id: "legal-definitions",
    title: "Definitions provided by the JO Legal Department",
    items: [
      {
        q: "Company Data",
        a: "Company Data is any information that JobsOhio creates, collects, receives, or maintains in the course of its business, in any form. This includes business, operational, financial, project, program, and customer or prospect information, as well as information that third parties provide to JobsOhio. Company Data may be public, internal, or confidential. Company Data that is designated as confidential, or that a reasonable person would understand to be confidential, is treated as Sensitive Information under the AI Governance Policy.",
      },
      {
        q: "Data Privacy",
        a: "Data privacy is an individual's ability to control their personal information and how it is collected, stored, used, and shared by others.",
      },
      {
        q: "Personal Identifiable Information",
        a: (
          <>
            Definition of Personal Identifiable Information at 4(K) of the AI Governance Policy -{" "}
            <span className="hc-quote">
              "Personal Identifiable Information (“PII”) – Data that can be used to directly or indirectly identify an individual. Examples include name, address, fingerprint, or date of birth. This is information is subject to applicable privacy laws."
            </span>
          </>
        ),
      },
      {
        q: "Sensitive Data",
        a: (
          <>
            AI Governance Policy defines sensitive data at Section 4 (L):{" "}
            <span className="hc-quote">
              "Sensitive Information – (i) Personal Information; (ii) material non-public information, as defined by the Securities and Exchange Commission; (iii) passwords, application programming interface (“API”) keys, or any other secrets that would allow an otherwise unauthorized actor to gain access to JobsOhio’s systems or data; and (iv) company data that is designated as confidential or that a reasonable person would understand to be confidential (e.g., business strategies, unannounced Project information, intellectual property, and trade secrets). NOTE: Cross reference your obligation to protect against any disclosure of Sensitive Information with the Standards of Conduct and your signed Non-Disclosure Agreement."
            </span>
          </>
        ),
      },
      {
        q: "Confidential Content",
        a: (
          <div className="hc-long">
            <div className="hc-long-item">
              <strong>1.</strong> Section 4(B) of the Standards of Conduct -{" "}
              <span className="hc-quote">
                "Confidentiality. All Directors, Officers, and employees are required to maintain the confidentiality of all information regarding the activities of the Corporation unless the disclosure of the information has been authorized, the information has been disclosed to the public or otherwise becomes public knowledge, the disclosure is required by a valid subpoena or court order, or the disclosure is otherwise required by applicable law or governmental regulation. No Director, Officer, or employee is permitted to disclose confidential information other than as permitted in the preceding sentence."
              </span>
            </div>
            <div className="hc-long-item">
              <strong>2.</strong> JobsOhio's NDA's definition of "Confidential Information:"{" "}
              <span className="hc-quote">
                "The term "Confidential Information" as used in this Agreement means all information disclosed, before or after the Effective Date, by Company to Employee, as well as any information to which Employee has access or that is learned, generated, or created by Employee, whether alone or jointly with others. Confidential Information includes, but is not limited to: (i) trade secrets or other information designated by the Company as confidential business or technical information of the Company or its customers, network partners or vendors, without limitation as to when or how Employee may have acquired such information; (ii) the Company’s methods of doing business and business techniques; (iii) customer lists and other customer and prospective customer information and other business information; (iv) vendor and supplier lists, pricing information and fee schedules; (v) employment, management and consulting agreements and other organizational information; (vi) trade secrets and other proprietary business and management methods; (vii) competitive analysis and strategies; (viii) all other technical, marketing, operational, economic, business, management, or financial knowledge, information or data of any nature whatsoever relating to the business of Company, which has been or may hereafter be learned, generated, created, or otherwise obtained by Employee, alone or jointly with others, whether in written, electronic, oral, or any other form; and (ix) any extracts therefrom. Confidential Information shall also include all non-public trade secret and commercial and financial information of any person, company or entity provided to Company under the terms of a duly executed Non-Disclosure Agreement or which is otherwise subject to obligations of confidentiality."
              </span>
            </div>
            <div className="hc-contact">
              If you have any additional questions regarding the definitions above, please contact Claudia
              Herrington (<a href="mailto:herrington@jobsohio.com">herrington@jobsohio.com</a>).
            </div>
          </div>
        ),
      },
    ],
  },
];
